<template>
  <div>
    <a-modal
      title="旅游门票手工下单"
      :visible="appointmentVisible"
      width="600px"
      @cancel="chose"
      :footer="null"
      :hotelData="hotelData"
    >
      <a-form-model ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol" :model="ruleForm" :rules="rules">
        <a-form-model-item label="商品名称">
          <div style="line-height: 20px;">{{ hotelData.proName }}</div>
        </a-form-model-item>
        <a-form-model-item label="票型">
          <a-select v-model="ruleForm.optionId" placeholder="请选择" @change="onChange" style="width: 100%;">
            <a-select-option v-for="(item, index) in hotelRatePlan" :value="item.optionId" :key="index">
              {{ item.optionName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="选择日期" :required="true">
          <div class="datePo">
            <div class="inputStyle" @click="chooseDate" v-if="afferentDate.checkInDate">
              {{ afferentDate.checkInDate }}&nbsp; {{ '星期' + afferentDate.weekDay }}
            </div>
            <div class="inputStyle" @click="chooseDate" v-else>请选择日期</div>
            <!--            <span class="spanPo" v-if="afferentDate.days">{{afferentDate.days}}晚</span>-->
          </div>
        </a-form-model-item>
        <a-card :bordered="false" title="订单填写">
          <a-form-model-item label="购买数" :required="true">
            <div class="houseNum">
              <img v-if="hotelNum == 1" src="../../../../../assets/images/reduce_unavailable2.png"/>
              <img v-else @click="reduceHouse" src="../../../../../assets/images/reduce_available2.png"/>
              <span>{{ hotelNum }}</span>
              <img @click="addHouse" src="../../../../../assets/images/add_available2.png"/>
            </div>
          </a-form-model-item>
          <a-form-model-item label="联系人" prop="contactName">
            <a-input style="width: 200px;" placeholder=" 请输入" v-model="ruleForm.contactName"/>
          </a-form-model-item>
          <a-form-model-item label="手机号码" prop="contactPhone">
            <a-input style="width: 200px;" placeholder=" 请输入" v-model="ruleForm.contactPhone" :maxLength="11"/>
          </a-form-model-item>
          <div v-for="(v, index) in contactOtherData" :key="index">
            <a-form-model-item :label="v.name" :required="true">
              <a-input style="width: 200px;" placeholder=" 请输入" v-model="v.text"/>
            </a-form-model-item>
          </div>
          <div v-for="(v, index) in checkInPersonList" :key="index">
            <a-form-model-item :label="k == 0 ? '游玩人' : '游玩人' + k" :required="true">
              <a-input style="width: 200px;" placeholder="请输入" v-model="v.travellersName"/>
            </a-form-model-item>
            <a-form-model-item label="证件类型" :required="true">
              <a-select placeholder="请选择" @change="(value) => onchangeChild(v, k, value)" style="width: 100%;">
                <a-select-option v-for="(item, index) in v.type" :value="item.code" :key="index">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="证件号码" :required="true">
              <a-input style="width: 200px;" placeholder="请输入" v-model="v.cardNo"/>
            </a-form-model-item>
          </div>
          <a-form-model-item label="备注">
            <a-input style="width: 200px;" placeholder=" 请输入" v-model="ruleForm.orderRemark"/>
          </a-form-model-item>
          <a-form-model-item label="订单金额">
            ￥<span style="color: red; font-size: 18px;">{{ (Number(afferentDate.money) * hotelNum).toFixed(2) }}</span>
          </a-form-model-item>
        </a-card>
        <a-form-model-item label=" " :colon="false" :required="false">
          <a-button type="primary" @click="saveEvent" :loading="saveLoading">提交订单</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!--日期选择-->
    <class-choose-date
      :title="title"
      :dateVisible="dateVisible"
      ref="child"
      :date="afferentDate"
      :hotelData="hotelData"
      @childDate="getDate"
    >
    </class-choose-date>
  </div>
</template>

<script>
import searchForm from '../../../../../utils/mixins/searchFormMixins'
import formMixin from '../../../../../utils/mixins/formMixins'
import ClassChooseDate from '@/views/service/serviceProvider/resourceControl/components/ClassChooseDate'

export default {
  name: 'HotelChooseDate',
  components: { ClassChooseDate },
  mixins: [searchForm, formMixin],
  data() {
    return {
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      mode: 'month',
      hotelMonth: [],
      newArr: [],
      parentDate: {},//传入父组件的date数据
      title: '',
      labelCol: { span: 6 },
      wrapperCol: { span: 10 },
      ruleForm: {
        optionId: '',
        contactName: '',
        contactPhone: '',
        orderRemark: ''
      },
      rules: {
        ratePlanId: [
          { required: true, message: '请选择价格计划', trigger: 'blur' }
        ],
        contactName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系人手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      },
      inputNumber: 1,
      dateVisible: false,
      afferentDate: {
        checkInDate: '', //入住时间/出游时间
        departureDate: '',// 离店时间 非酒店类型传null ,
        money: 0,//订单单价
        proType: 1,//商品类型 1是酒店 否则其他
        days: 0,//天数
        minStock: 1,//最小数量
        weekDay: ''
      },
      hotelRatePlan: {},
      hotelNum: 1,
      checkInPersonList: [],
      currentTicket: {},
      TouristInfoList: '',
      TouristInfoListArr: [],
      contactOtherInfo: [],
      contactInfoList: [],
      contactOtherData: []
    }
  },
  props: {
    hotelData: {
      type: Object,
      default: null
    },
    appointmentVisible: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.TouristInfoList = this.getAppConstants().getTouristInfoList()
    this.contactInfoList = this.getAppConstants().getContactInfoList()
  },
  mounted() {
    this.title = '选择日期'
  },
  methods: {
    onchangeChild(item, index, value) {
      this.checkInPersonList[index].cardType = value
    },
    onChange(value) {
      this.hotelRatePlan.forEach(v => {
        if (v.optionId == value) {
          this.currentTicket = v
        }
      })
      this.contactOtherInfo = this.currentTicket.contactMustInfo ? this.currentTicket.contactMustInfo.split(',') : []
      this.contactOtherInfo = this.contactOtherInfo.filter((item, i, a) => item > 2)
      this.contactOtherInfo.forEach(v => {
        this.contactInfoList.forEach(v1 => {
          if (v == v1.code) {
            this.contactOtherData.push({
              id: v,
              is: true,
              name: v1.name,
              text: ''
            })
          }
        })
      })
      this.getLogUtils().logWithTag('contactOtherData', this.contactOtherData)
      this.TouristInfoListArr = this.currentTicket.optionCardList ? this.currentTicket.optionCardList.split(',') : []
      this.TouristInfoList.forEach(v => {
        this.TouristInfoListArr.forEach((v1, k) => {
          if (v.code == v1) {
            this.TouristInfoListArr[k] = v
          }
        })
      })
      if (this.currentTicket.bespeakNeedCardType >= 2) {
        this.checkInPersonList = [
          {
            cardNo: '',// 出游人证件号 ,
            cardType: '',// 出游人证件类型 ,
            travellersName: '',// 入住人/出游人 名称
            type: this.TouristInfoListArr
          }
        ]
      }
    },
    addHouse() {
      this.getLogUtils().logWithTag('afferentDate', this.afferentDate)
      if (!this.ruleForm.optionId) {
        this.$message.error('请选择价格计划')
        return false
      }
      if (!this.afferentDate.checkInDate && !this.afferentDate.departureDate) {
        this.$message.error('请选择时间')
        return false
      }
      if (this.hotelNum >= this.afferentDate.minStock) {
        this.$message.error('库存已是最大值')
        return
      }
      this.hotelNum += 1
      if (this.currentTicket.bespeakNeedCardType > 2) {
        this.checkInPersonList.push({
          cardNo: '',// 出游人证件号 ,
          cardType: '',// 出游人证件类型 ,
          travellersName: '',// 入住人/出游人 名称
          type: this.TouristInfoListArr
        })
      }
    },
    reduceHouse() {
      if (this.hotelNum <= 1) {
        return
      }
      this.hotelNum -= 1
      if (this.currentTicket.bespeakNeedCardType > 2) {
        this.checkInPersonList.splice(this.checkInPersonList.length - 1, 1)
      }
    },
    getDate(data) {
      this.afferentDate = data
      this.dateVisible = false
    },
    getHotelPanList(type) {
      let parm = {
        proCatalogId: type.proCatalogId,
        proId: type.proId
      }
      this.getHttpServices().getProService().post('resource/pro/get/proOption', parm)
        .then(res => {
          this.hotelRatePlan = res
          this.afferentDate = {
            checkInDate: '', //入住时间/出游时间
            departureDate: '',// 离店时间 非酒店类型传null ,
            money: 0,//订单单价
            proType: 1,//商品类型 1是酒店 否则其他
            days: 0,//天数
            minStock: 1,//最小数量
            weekDay: ''
          }
          this.hotelNum = 1
          this.ruleForm = {
            ratePlanId: '',
            contactName: '',
            contactPhone: '',
            orderRemark: ''
          }
          this.contactOtherData = []
          this.checkInPersonList = []
          this.TouristInfoListArr = []
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    chooseDate() {
      this.getLogUtils().logWithTag('hotelData', this.hotelData)
      if (!this.ruleForm.optionId) {
        this.$message.error('请选择票型计划')
        return false
      }
      this.hotelData.ratePlanId = this.ruleForm.optionId
      this.$refs.child.getMonthHotel()
      this.dateVisible = true
    },
    saveEvent() {
      let conFlag = true
      this.contactOtherData.some(v => {
        if (!v.text) {
          conFlag = false
          this.$message.error('请填写' + v.name)
          return false
        }
      })
      if (!conFlag) {
        return false
      }
      this.getLogUtils().logWithTag('contactOtherData', this.contactOtherData)
      let flag = true
      let flag2 = true
      let flag3 = true
      this.checkInPersonList.forEach(v => {
        if (!v.travellersName) {
          flag = false
        }
        if (!v.cardType) {
          flag2 = false
        }
        if (!v.cardNo) {
          flag3 = false
        }
      })
      if (!flag) {
        this.$message.error('请填写游玩人姓名')
        return false
      }
      if (!flag2) {
        this.$message.error('请选择证件类型')
        return false
      }
      if (!flag3) {
        this.$message.error('请填写游玩人证件号码')
        return false
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.checkInPersonList.forEach(v => {
        delete v.type
      })
      let optionName = ''
      this.hotelRatePlan.forEach(v => {
        if (this.ruleForm.optionId == v.optionId) {
          optionName = v.optionName
        }
      })
      let params = {
        breakfastNum: null,//早餐数量 非酒店类型传null ,
        checkInDate: this.afferentDate.checkInDate,//入住时间/出游时间 ,
        contactName: this.ruleForm.contactName,//联系人名称 ,
        contactOtherInfoList: this.contactOtherData,//订单联系人其他信息 ,
        contactPhone: this.ruleForm.contactPhone,
        departureDate: null,//离店时间 非酒店类型传null ,
        optionId: this.ruleForm.optionId,//套餐ID
        optionName,//套餐名称
        orderAmount: Number(this.afferentDate.money) * this.hotelNum,//订单金额 ,
        orderRemark: this.ruleForm.orderRemark,
        proCatalog: this.hotelData.proCatalogId,//商品类型
        proId: this.hotelData.proId,
        proName: this.hotelData.proName,
        purchaseQuantity: this.hotelNum,
        ratePlanId: null,
        ratePlanName: null,
        travellersDtoList: this.checkInPersonList
      }
      this.getHttpServices().getOrderService().post('resources/order/add/handworkOrder', params)
        .then(res => {
          this.$message.success('下单成功')
          this.$emit('choseDate')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    chose() {
      //this.hotelVisible = false
      // this.checkStock(this.date.departureDate, this.date.checkInDate, this.date.departureDate)
      this.$emit('choseDate')
    }
  }
}
</script>
<style lang="less" scoped>
.ant-modal-body {
  min-height: 400px;
}

.inputStyle {
  width: 100%;
  border: 1px #d9d9d9 solid;
  border-radius: 5px;
  padding: 0 5px;
  cursor: pointer;
  display: inline-block;
}

.datePo {
  position: relative;

  .spanPo {
    display: block;
    position: absolute;
    top: 2px;
    right: -40px;
    color: red;
  }
}

.houseNum {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  img {
    width: 30px;
    height: 30px;
    cursor: pointer;
  }

  span {
    display: inline-block;
    width: 30px;
    line-height: 28px;
    text-align: center;
    border: 1px #d9d9d9 solid;
  }
}
</style>
